import React, { Component } from 'react';

class CounterBadge extends Component {

  render() {

    const { 
    	text, 
    	count, 
    	percent 
    } = this.props

    return (
      <div className='b-counter'>
        { text } 
        { count &&
        	<b> { count }</b>
        }
        { percent &&
        	<b> ({ percent })</b>
        }
      </div>  
    )
  };
}

export default CounterBadge;



// WEBPACK FOOTER //
// ./src/components/CounterBadge/CounterBadge.js